"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.PFAHeroV2 = void 0;
var _pfaHeroV = _interopRequireDefault(require("./components/pfa-hero-v2"));
exports.PFAHeroV2 = _pfaHeroV["default"];